import { render } from "./NotificationBox.vue?vue&type=template&id=5629d8a8&scoped=true"
import script from "./NotificationBox.vue?vue&type=script&lang=js"
export * from "./NotificationBox.vue?vue&type=script&lang=js"

import "./NotificationBox.vue?vue&type=style&index=0&id=5629d8a8&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5629d8a8"]])

export default __exports__